<template>
  <el-dialog :title="title" :visible="loginBoxShow" width="600px" center @close="closeSubmit">
    <Login
      v-if="formType === 'checkLogin'"
      ref="checkLogin"
      :formType.sync="formType"
      @loginBoxHide="closeSubmit"
    />
    <FindPhone
      v-else
      ref="findPhone"
      :formType.sync="formType"
      :findStatus.sync="findStatus"
    />
    <div
      v-if="['success', 'fail'].includes(findStatus)"
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="closeSubmit">我知道了</el-button>
    </div>
    <div v-else slot="footer" class="dialog-footer">
      <el-button @click="closeSubmit">取 消</el-button>
      <el-button type="primary" @click="submitForm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {Dialog, Button } from 'element-ui'
import Login from "./check-login.vue"
import FindPhone from "./find-phone.vue"
export default {
  name: "login",
  components: {
    ElButton: Button,
    ElDialog: Dialog,
    Login,
    FindPhone
  },
  props:{
    loginBoxShow: Boolean
  },
  data() {
    return {
      formType: 'checkLogin', // 'findPhone'
      findStatus: 'noSubmit' // success fail noSubmit
    };
  },
  computed: {
    title() {
      const titleList = {
        checkLogin: '登录',
        findPhone: '找回报名手机号'
      };
      return titleList[this.formType];
    }
  },
  methods: {
    submitForm() {
      this.$refs[this.formType].submitForm();
    },
    closeSubmit(){
      this.$emit('loginBoxHide')
    },
  }
}
</script>

<style lang="less" scoped>
/deep/.el-dialog {
  min-height: 357px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>